'use client';

import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import { Fragment } from 'react';

import {
	Button,
	ButtonProps,
	ChevronBottomIcon,
	DropdownItem,
	DropdownItemProps,
} from '@/shared';

export type DropdownProps = {
	anchor?: 'bottom start' | 'bottom end' | 'top start' | 'top end';
	variant?: ButtonProps['variant'];
	size?: ButtonProps['size'];
	label?: string;
	items: DropdownItemProps[];
};

export const Dropdown = ({
	anchor = 'bottom start',
	variant,
	size,
	label,
	items,
}: DropdownProps) => {
	return (
		<Menu>
			<MenuButton as={Fragment}>
				{() => (
					<Button type="button" size={size} variant={variant}>
						{label} <ChevronBottomIcon className="size-5" />
					</Button>
				)}
			</MenuButton>
			<MenuItems
				anchor={anchor}
				transition
				className="z-50 rounded-lg bg-white p-2 shadow-listbox ring-1 ring-inset ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
			>
				{items.map((item, index) => (
					<DropdownItem key={index} {...item} />
				))}
			</MenuItems>
		</Menu>
	);
};
